const translations = {
    connected: 'Connected',
    disconnect: 'Not Connected'
};

export default translations;
